import React, { FC, forwardRef } from 'react';
import { Entry } from '@trip-ux/components';
import { SUPPORTED_LOCALES } from '@trip-ux/constants';
import { checkCurrency, blurCheck } from '../../utils';
import { GenericInputType } from './GenericInputType';

export const GenericInputCurrency: FC<GenericInputType> = forwardRef(({ input, config, meta, ...rest }, ref) => (
  <div>
    <Entry
      {...input}
      {...rest}
      onChange={e => checkCurrency(e, config.locale as SUPPORTED_LOCALES, input.onChange)}
      onBlur={e => blurCheck(e, config.locale as SUPPORTED_LOCALES, input.onBlur)}
      ref={ref}
    />
  </div>
));
GenericInputCurrency.displayName = 'GenericInputCurrency';
